import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);
const API = 'https://staging-api.dopscale.com';
const KEY = 'adintel_token';
const KEY_USER = 'adintel_user';

async function apiFetch(path, token, options = {}) {
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(KEY);
    if (!token) { setLoading(false); return; }

    apiFetch('/auth/me', token)
      .then(res => {
        const d = res.data || res;
        setUser(d.user);
      })
      .catch(() => {
        // Fallback: user cacheado do ultimo login
        try {
          const cached = localStorage.getItem(KEY_USER);
          if (cached) setUser(JSON.parse(cached));
        } catch {}
      })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const res = await apiFetch('/auth/login', null, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    const d = res.data || res;
    if (d.token) {
      localStorage.setItem(KEY, d.token);
      if (d.user) localStorage.setItem(KEY_USER, JSON.stringify(d.user));
      setUser(d.user);
    }
    return d;
  }

  function logout() {
    localStorage.removeItem(KEY);
    localStorage.removeItem(KEY_USER);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, isAuthenticated: user !== null, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
